import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, ListGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { getErrorMessageKey } from '../../../../utils/helper';
import { loadChats } from '../../../../actions/chats';
import { sendMessage } from '../../../../utils/Api';
import Pagination from '../../../../components/_Pagination';
import Loading from '../../Loading';
import ChatItem from '../../ChatItem';
import StartChat from '../../StartChat';

const mapStateToProps = ({ chats, i18n: { translations } }) => ({
  page: chats.page,
  itemsPerPage: chats.itemsPerPage,
  list: chats.list,
  count: chats.count,
  isLoaded: chats.isLoaded,
  translations,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loadContent: loadChats,
}, dispatch);

class Chats extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToChat: 0,
      isLoaded: true,
    };

    this.send = this.send.bind(this);
  }

  componentDidMount() {
    const { page, loadContent } = this.props;
    loadContent(page);
  }

  send(chatId) {
    this.setState({ isLoaded: false });
    const { intl, message, translations, onAddComplete } = this.props;
    sendMessage(chatId, { forwarded_message: message }).then(({ error }) => {
      if (!error) {
        this.setState({ redirectToChat: chatId });
        onAddComplete(chatId);
      } else {
        const errorMessage = getErrorMessageKey(translations, error.code) || error.msg;
        alert(intl.formatMessage({ id: errorMessage }) || 'error forwarding message');
        this.setState({ isLoaded: true });
      }
    });
  }

  render() {
    const { redirectToChat, isLoaded: isLoadedState } = this.state;
    if (redirectToChat) {
      return <Redirect to={`/trainings/chats/${redirectToChat}`} />;
    }
    const { page, itemsPerPage, list, count, isLoaded, loadContent } = this.props;

    return (
      <div>
        {!isLoadedState && <Loading />}
        <StartChat
          actionType="add"
          onAddComplete={id => this.send(id)}
        />
        {!isLoaded && <Loading />}{list && (
        <React.Fragment>
          <ListGroup>{list.map(item => (
            <ChatItem
              key={item.id}
              {...item}
              handleClick={(ev) => {
                ev.preventDefault();
                this.send(item.id);
              }}
            />
          ))}</ListGroup>
          <div className="chat_pagination">
            <Pagination
              activePage={page}
              itemsPerPage={itemsPerPage}
              totalItems={count}
              onChange={loadContent}
            />
          </div>
        </React.Fragment>)}
      </div>
    );
  }
}

Chats.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  page: PropTypes.number,
  itemsPerPage: PropTypes.number,
  list: PropTypes.arrayOf(PropTypes.any),
  count: PropTypes.number,
  isLoaded: PropTypes.bool,
  loadContent: PropTypes.func.isRequired,
  onAddComplete: PropTypes.func.isRequired,
};

const ChatsComponent = connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(Chats)));

class Forward extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowed: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    const { isShowed } = this.state;
    this.setState({ isShowed: !isShowed });
  }

  render() {
    const { isShowed } = this.state;
    const { message, onAddComplete } = this.props;

    return (
      <React.Fragment>
        <Modal isOpen={isShowed} toggle={this.toggle} className="modal-1 modal-lg">
          <ModalHeader><FormattedMessage id="messages_chooseOrCreate" /></ModalHeader>
          <ModalBody className="align-items-center">{isShowed &&
            <ChatsComponent message={message} onAddComplete={onAddComplete} />}
          </ModalBody>
          <ModalFooter>
            <Button color="1" onClick={this.toggle}><FormattedMessage id="overall_input_cancel" /></Button>
          </ModalFooter>
        </Modal>
        <Button className="forward_button" onClick={this.toggle}><i className="fa fa-share" /></Button>
      </React.Fragment>
    );
  }
}

Forward.propTypes = {
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  onAddComplete: PropTypes.func.isRequired,
};

export default Forward;



// WEBPACK FOOTER //
// ./src/views/_Chats/Messages/New/Forward.js